import { colonyAPI } from '@/api';
import axios from 'axios';
import * as types from './mutation-types';

export default {
  updateUserCompany({ commit }, payload) {
    commit(types.UPDATE_COMPANY_USER_REQUEST);
    colonyAPI
      .patch(`accounts/users/${payload.user}/`, { use_as_company: payload.company })
      .then(() => location.reload())
      .catch(() => commit(types.UPDATE_COMPANY_USER_FAILURE));
  },

  getMe({ commit }) {
    commit(types.GET_ME_REQUEST);
    colonyAPI
      .get('accounts/users/me/')
      .then(response => commit(types.GET_ME_SUCCESS, response.data))
      .catch(() => commit(types.GET_ME_FAILURE));
  },

  getGroups({ commit }) {
    commit(types.GET_GROUPS_REQUEST);
    colonyAPI
      .get('accounts/groups/')
      .then(response => commit(types.GET_GROUPS_SUCCESS, response))
      .catch(error => commit(types.GET_GROUPS_FAILURE, error));
  },

  getCompanyUsers({ commit }) {
    colonyAPI
      .get('accounts/users/?org_users=True')
      .then(response => commit(types.GET_COMPANY_USERS_SUCCESS, response))
      .catch(error => commit(types.GET_COMPANY_USERS_FAILURE, error));
  },

  saveUser({ commit, dispatch }, payload) {
    commit(types.UPDATE_COMPANY_USER_REQUEST);
    const apiMethod = payload.id
      ? colonyAPI.put(`accounts/users/${payload.id}/`, payload)
      : colonyAPI.post('accounts/users/', payload);

    return apiMethod
      .then(response => commit(types.UPDATE_COMPANY_USER_SUCCESS, response))
      .then(() => dispatch('getCompanyUsers'))
      .catch(error => commit(types.UPDATE_COMPANY_USER_FAILURE, error));
  },

  deleteUser({ commit, dispatch }, payload) {
    commit(types.UPDATE_COMPANY_USER_REQUEST);
    const apiMethod = payload.id
      ? colonyAPI.delete(`accounts/users/${payload.id}/`, payload)
      : colonyAPI.post('accounts/users/', payload);

    return apiMethod
      .then(response => commit(types.UPDATE_COMPANY_USER_SUCCESS, response))
      .then(() => dispatch('getCompanyUsers'))
      .catch(error => commit(types.UPDATE_COMPANY_USER_FAILURE, error));
  },

  updateUserProfile({ commit, dispatch }, payload) {
    commit(types.UPDATE_USER_PROFILE_REQUEST);
    colonyAPI
      .patch(`accounts/users/${payload.id}/`, payload.form)
      .then(response => commit(types.UPDATE_USER_PROFILE_SUCCESS, response))
      .then(() => dispatch('user/getMe', null, { root: true }))
      .catch(() => commit(types.UPDATE_USER_PROFILE_FAILURE));
  },

  getBrowserLocale({ commit }) {
    commit(types.UPDATE_USER_LOCALE_REQUEST);

    return axios
      .get('https://api.ipdata.co')
      .then(response => commit(types.UPDATE_USER_LOCALE_SUCCESS, response))
      .catch(() => commit(types.UPDATE_USER_LOCALE_FAILURE));
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/user/actions.js